import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ApiKey from 'Components/api/ApiKey';
import BaseApi from 'Components/api/BaseApi';

import { candidateSidebarSections } from './candidate-sidebar.config';
import { CandidateSidebarSectionView } from './candidate-sidebar-section';
import { CandidateSidebarAction } from './candidate-sidebar.types';
import './candidate-sidebar.scss';

const CandidateSidebar = () => {
   const navigate = useNavigate();
   const { t } = useTranslation('global');
   const tokenKey = Cookies.get('tokenClient');

   const handleLogout = async () => {
      try {
         const confirmationResult = await Swal.fire({
            icon: 'question',
            showCancelButton: true,
            text: t('jobseekerSidebar.confirmTxt'),
            title: t('jobseekerSidebar.confirmTitle'),
            cancelButtonText: t('jobseekerSidebar.no'),
            confirmButtonText: t('jobseekerSidebar.yes'),
         });

         if (!confirmationResult.isConfirmed) {
            return;
         }

         await axios.post(`${BaseApi}/users/logout`, null, {
            headers: {
               key: ApiKey,
               token: tokenKey,
               'Content-Type': 'application/json',
            },
         });

         Cookies.remove('fname');
         Cookies.remove('user_id');
         Cookies.remove('user_type');
         Cookies.remove('tokenClient');

         navigate('/');
         window.location.reload();

         const toast = Swal.mixin({
            timer: 3000,
            toast: true,
            position: 'top-end',
            timerProgressBar: true,
            showConfirmButton: false,
            didOpen: (toastElement) => {
               toastElement.addEventListener('mouseenter', Swal.stopTimer);
               toastElement.addEventListener('mouseleave', Swal.resumeTimer);
            },
         });

         toast.fire({
            icon: 'success',
            title: t('jobseekerSidebar.successTitle'),
         });
      } catch {
         Swal.fire({
            icon: 'error',
            title: t('jobseekerSidebar.failedTitle'),
            confirmButtonText: t('jobseekerSidebar.close'),
         });
      }
   };

   const handleSectionAction = (action: CandidateSidebarAction) => {
      if (action === 'logout') {
         handleLogout();
      }
   };

   return (
      <div className="candidate-sidebar-refactor">
         {candidateSidebarSections.map((section) => (
            <CandidateSidebarSectionView
               key={section.id}
               section={section}
               onActionClick={handleSectionAction}
               t={t}
            />
         ))}
      </div>
   );
};

export default CandidateSidebar;
